<template>
  <SheetOverlay :model-value="showUpdateAppOverlay" fixed z-index="999">
    <v-row>
      <v-col cols="12" class="pt-0 pb-2">
        <h2 class="text-h5 font-weight-semibold" v-text="$t('overlay.update.title')" />
        <p class="text-body-1 text-neutral600" v-text="$t('overlay.update.description')" />
      </v-col>

      <v-col cols="12">
        <BrandButton
          variant="secondary" size="large" block link
          target="_blank"
          rel="noopener noreferrer"
          :href="links.news"
        >
          {{ $t('common.update.what_is_new') }}
        </BrandButton>
      </v-col>

      <v-col cols="12">
        <BrandButton
          :variant="!(isExtension || isExtensionPopup) ? 'secondary' : 'primary'" size="large" block link
          target="_blank"
          rel="noopener noreferrer"
          :href="links.howTo"
        >
          {{ $t('common.update.how_to_update') }}
        </BrandButton>
      </v-col>

      <v-col v-if="!(isExtension || isExtensionPopup)" cols="12">
        <BrandButton
          variant="primary" size="large" block link
          target="_blank"
          rel="noopener noreferrer"
          :href="links.updateNow"
        >
          {{ $t('common.update.update_now') }}
        </BrandButton>
      </v-col>
    </v-row>
  </SheetOverlay>
</template>

<script setup>
import { computed } from 'vue'
import { useStore } from 'vuex'
import { useTranslation } from '@/composables/useTranslation'
import { useDeviceAware } from '@/composables/useDeviceAware'
import SheetOverlay from '@/components/overlays/SheetOverlay.vue'
import { HOW_TO_UPDATE_APP_LINKS, UPDATE_APP_LINKS, UPDATE_NEWS_LINKS } from '@/utils/constants'

const store = useStore()
const { locale } = useTranslation()
const { isExtension, isExtensionPopup, isDesktop, isMobile, deviceInfo } = useDeviceAware()

const showUpdateAppOverlay = computed(() => store.getters['device/showUpdateAppOverlay'])

const links = computed(() => {
  const linksObj = {
    news: UPDATE_NEWS_LINKS[locale.value],
    howTo: '',
    updateNow: '',
  }

  const browser = deviceInfo.value.browser?.toLowerCase()

  if (browser && (isDesktop.value || isExtension.value || isExtensionPopup.value)) {
    if (browser.includes('chrome')) {
      linksObj.howTo = HOW_TO_UPDATE_APP_LINKS.chrome[locale.value]
      linksObj.updateNow = UPDATE_APP_LINKS.chrome
    }
    if (browser.includes('firefox')) {
      linksObj.howTo = HOW_TO_UPDATE_APP_LINKS.firefox[locale.value]
      linksObj.updateNow = UPDATE_APP_LINKS.firefox
    }
    if (browser.includes('edge')) {
      linksObj.howTo = HOW_TO_UPDATE_APP_LINKS.edge[locale.value]
      linksObj.updateNow = UPDATE_APP_LINKS.edge
    }
    if (browser.includes('safari')) {
      linksObj.howTo = HOW_TO_UPDATE_APP_LINKS.safari[locale.value]
      linksObj.updateNow = UPDATE_APP_LINKS.safari
    }
  }

  if (isMobile.value) {
    if (deviceInfo.value.os === 'ios') {
      linksObj.howTo = HOW_TO_UPDATE_APP_LINKS.ios[locale.value]
      linksObj.updateNow = UPDATE_APP_LINKS.ios
    }
    if (deviceInfo.value.os === 'android') {
      linksObj.howTo = HOW_TO_UPDATE_APP_LINKS.android[locale.value]
      linksObj.updateNow = UPDATE_APP_LINKS.android
    }
  }

  return linksObj
})
</script>
